import { render, staticRenderFns } from "./TargetSettings.vue?vue&type=template&id=d34227ba&scoped=true&"
import script from "./TargetSettings.vue?vue&type=script&lang=ts&"
export * from "./TargetSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d34227ba",
  null
  
)

export default component.exports